import { render, staticRenderFns } from "./dialogNumberDetail.vue?vue&type=template&id=33c635d2&lang=pug"
import script from "./dialogNumberDetail.vue?vue&type=script&lang=js"
export * from "./dialogNumberDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports